import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import Row from 'src/components/Row';
import './RoomAccordionSkeleton.scss';

const ROOM_COUNT: number = 4;
const EXPANDED_ROOM_INDEX: number = 0;
const ASSET_CARD_COUNT_IN_EXPANDED: number = 5;

// Mirrors RoomAccordionList: each room is a header (label + chevron + delete),
// and the first one is rendered "expanded" with a Row of AreaDocument-shaped
// asset card skeletons inside (icon + headline + strapline) so users see the
// real layout shape (e.g. Balcony, Kitchen + items grid) immediately.
const RoomAccordionSkeleton = () => (
  <div className="room-accordion-skeleton">
    {Array.from({ length: ROOM_COUNT }, (_, index: number) => (
      <div key={`room-skeleton-${index}`} className="room-accordion-skeleton-item">
        <div className="room-accordion-skeleton-header">
          <span className="room-accordion-skeleton-header-label">
            <Skeleton variant="text" width="9rem" />
          </span>
          <div className="room-accordion-skeleton-header-actions">
            <Skeleton variant="text" width="1rem" />
            <div className="room-accordion-skeleton-header-delete">
              <Skeleton variant="text" width="1rem" />
            </div>
          </div>
        </div>
        {index === EXPANDED_ROOM_INDEX && (
          <Row style={{ marginLeft: '0px', marginRight: '0px' }}>
            {Array.from(
              { length: ASSET_CARD_COUNT_IN_EXPANDED },
              (_, assetIndex: number) => (
                <AreaDocumentCardSkeleton
                  key={`expanded-asset-skeleton-${assetIndex}`}
                />
              )
            )}
          </Row>
        )}
      </div>
    ))}
  </div>
);

// Mirrors the real asset card render: an outer cell (which carries the
// responsive width — two cards per row on mobile) around the card itself
// (icon on top + details block underneath).
const AreaDocumentCardSkeleton = () => (
  <div className="room-accordion-skeleton-card">
    <div className="room-accordion-skeleton-card-inner">
      <div className="room-accordion-skeleton-item-card">
        <div className="room-accordion-skeleton-icon">
          <Skeleton variant="rect" width="3rem" height="3rem" />
        </div>
        <div className="room-accordion-skeleton-details">
          <div className="room-accordion-skeleton-headline">
            <Skeleton variant="text" width="80%" />
          </div>
          <div className="room-accordion-skeleton-strapline">
            <Skeleton variant="text" width="55%" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default RoomAccordionSkeleton;
